export const onCloseModal = ({ setStateDialogTemplate }) => {
    return setStateDialogTemplate(false);
};
export const onConfirmModal = ({ mutate }) => {
    return mutate();
};
export const onOpenModal = ({ setStateDialogTemplate }) => {
    return setStateDialogTemplate(true);
};
